/**
 * P2-04 · <ProductCardSkeleton> — the streaming-grid placeholder (P2-DB04
 * §04): media block at the card's fixed 4:5 ratio + title and price lines,
 * plus the swatch row when the brand shows swatches, so the box matches the
 * real card and nothing reflows when data lands (no CLS).
 */
import { cn } from "~/lib/utils";

export function ProductCardSkeleton({
  showSwatches = true,
  className,
}: {
  showSwatches?: boolean;
  className?: string;
}) {
  return (
    <div
      aria-hidden
      className={cn(
        "animate-pulse overflow-hidden rounded-[var(--radius-lg)] border border-border bg-surface",
        className,
      )}
    >
      <div className="aspect-[4/5] bg-surface-2" />
      <div className="p-3">
        <div className="h-4 w-4/5 rounded-[var(--radius-sm)] bg-surface-2" />
        <div className="mt-2 h-4 w-2/5 rounded-[var(--radius-sm)] bg-surface-2" />
        {showSwatches && (
          <div className="mt-3 flex gap-1.5">
            <span className="size-5 rounded-full bg-surface-2" />
            <span className="size-5 rounded-full bg-surface-2" />
            <span className="size-5 rounded-full bg-surface-2" />
          </div>
        )}
      </div>
    </div>
  );
}
